import { useContext, useEffect } from 'react'
import { TextAreaField } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './SupportingStatement.module.scss'

export const SupportingStatement = ({ confirm, initialBio, maxChars = 1000 }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const validationSchema = Yup.object({
    description: Yup.string().required('Description is required'),
  })

  const initialValues = {
    description: initialBio || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      confirm(values.description)
      onClose()
    },
  })

  useEffect(() => {
    setHeaderLabel(t('Add Bio'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.save'), onClick: formik.handleSubmit },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <TextAreaField
        formik={formik}
        field='description'
        label='English'
        placeholder='Enter statement here'
        maxChars={maxChars}
        style={{ container: { minHeight: '300px' } }}
      />
    </div>
  )
}
